import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'

import { setLoading } from './loading'

import { API } from 'src/services/config'

export interface UsersProps {
  data: {
    documento: string,
    nome: string,
    senha: string,
    sobrenome: string
    telefone: string,
    idFazenda: string,
    perfil: string,
  }
  username: string
}

export interface StoreProps {
  data?: {
    documento?: string,
    nome?: string,
    senha?: string,
    sobrenome?: string
    telefone?: string,
    idFazenda?: string,
    perfil?: string,
  }
  descricao?: string
  username?: string
}

export interface UsersState {
  list: Array<UsersProps>
}

const customModule = '@USERS'

const SET_FETCHING = `${customModule}/SET_FETCHING`

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const STORE = {
  REQUEST: `${customModule}/STORE_REQUEST`,
  SUCCESS: `${customModule}/STORE_SUCCESS`,
}

const STORE_USER = {
  REQUEST: `${customModule}/STORE_USER_REQUEST`,
  SUCCESS: `${customModule}/STORE_USER_SUCCESS`,
}

const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`,
}

const initialState: UsersState = {
  list: []
}

export const usersReducer: Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case GET.SUCCESS:
    return { ...state, list: payload }

  case STORE.SUCCESS: {
    const { list } = state
    const newList = [...list]
    newList.unshift(payload)
    return { ...state, list: newList }
  }

  case STORE_USER.SUCCESS: {
    const { list } = state
    const newList = [...list]
    const newPayload = {
      username: payload.username,
      data: {
        nome: payload.nome,
        sobrenome: payload.sobrenome,
        documento: payload.documento,
        idFazenda: payload.idFazenda,
        telefone: payload.telefone,
        perfil: payload.perfil,
      }
    }
    newList.unshift(newPayload)
    return { ...state, list: newList }
  }

  case UPDATE.SUCCESS: {
    const { list } = state
    const newList = list.map((item: any) => {
      const newPayload = {
        username: payload.username,
        data: {
          nome: payload.nome,
          sobrenome: payload.sobrenome,
          documento: payload.documento,
          idFazenda: payload.idFazenda,
          telefone: payload.telefone,
          perfil: payload.perfil,
        }
      }
      if (item.username === payload.username) return newPayload
      return item
    })
    return { ...state, list: newList }
  }

  default:
    return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getUsers = (data: string) => ({ type: GET.REQUEST, payload: data })
export const createUsers = (data: StoreProps) => ({ type: STORE.REQUEST, payload: data })
export const updateUsers = (data: StoreProps) => ({ type: UPDATE.REQUEST, payload: data })

export const createUser = (data: StoreProps) => ({ type: STORE_USER.REQUEST, payload: data })

const ROUTE = '/domain/Usuario'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, ROUTE)
    const farmList = data.filter((item: any) => item.data.idFazenda === payload)
    yield put({ type: GET.SUCCESS, payload: farmList })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar'
    toast.error(message)
    yield put(setLoading(false))
  }
}

// eslint-disable-next-line
function* store({ payload: { descricao, ...rest } }: SagaAction<StoreProps>) {
  try {
    yield put(setFetching(true))
    const { data: { idFazenda } }: GetResponse<any> = yield API.put(
      '/entity/Fazenda', { descricao, proprietario: `${rest.data?.nome} ${rest.data?.sobrenome}` }
    )
    const { data }: GetResponse<any> = yield API.put(`${ROUTE}/${'username'}/${rest.username}`, { ...rest, idFazenda })
    yield put({ type: STORE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

// eslint-disable-next-line
function* storeUser({ payload }: SagaAction<StoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(`${ROUTE}/username/${payload.username}`, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Cadastrado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Cadastrar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: STORE_USER.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

// eslint-disable-next-line
function* update({ payload }: SagaAction<StoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(`${ROUTE}/${'username'}/${payload.username}`, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Atualizado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Atualizar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: UPDATE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

export const usersSaga = all([
  takeLatest(GET.REQUEST, get),
  takeLatest(STORE.REQUEST, store),
  takeLatest(UPDATE.REQUEST, update),

  takeLatest(STORE_USER.REQUEST, storeUser),
])
